module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "acont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Title",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("TITLE PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("COPYRIGHT PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "rintr"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("What Are Fatphobia and Diet Culture?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Restriction Doesn’t Work: It’s Not You")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dieting: Family, Assimilation, and Bootstrapping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dieting Is a Survival Technique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Internalized Inferiority and Sexism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bros "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/common.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/common.jpg",
      "width": "17"
    }
  })]), _vm._v(" Thinness: Heteromasculinity and Whiteness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatphobia Is the New Language of Classism and Racism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Early Fat Activism Taught Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Future, I’m Fat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Want Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Have the Right to Remain Fat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "notes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "also"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Also_By",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALSO BY FEMINIST PRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ABOUT FEMINIST PRESS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 63
// module chunks = 0